import React from 'react';

const pulse = 'animate-pulse rounded-lg bg-gray-200';

function SectionBlock({ rows = 3 }) {
  return (
    <div className="rounded-lg border border-[#f3f4f6] bg-white p-3 sm:p-6 shadow-sm">
      <div className="mb-4 flex items-center justify-between">
        <div className={`h-5 w-40 ${pulse}`} />
        <div className={`h-5 w-5 rounded ${pulse}`} />
      </div>
      <div className="space-y-3">
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <div className={`h-10 w-full ${pulse}`} />
            <div className={`h-10 w-full ${pulse}`} />
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * Skeleton do cadastro/edição de imóvel ou condomínio.
 * Usado no Suspense, ProtectedRoute e hidratação interna do formulário.
 */
export default function PropertyFormSkeleton({ titleWidth = 'w-48' } = {}) {
  return (
    <div
      className="max-w-4xl mx-auto p-3 sm:p-6 mb-[85px] font-montserrat font-light min-h-[70vh]"
      aria-busy="true"
      aria-label="Carregando formulário"
    >
      <div className={`mx-auto mb-4 sm:mb-6 h-7 sm:h-8 ${titleWidth} ${pulse}`} />

      <div className="space-y-3 sm:space-y-6">
        <div className="rounded-lg border border-[#f3f4f6] bg-white p-3 sm:p-6 shadow-sm">
          <div className={`mb-2 h-4 w-28 ${pulse}`} />
          <div className={`h-11 w-full ${pulse}`} />
        </div>

        <SectionBlock rows={2} />
        <SectionBlock rows={3} />
        <SectionBlock rows={2} />
        <SectionBlock rows={1} />
      </div>

      <div className="fixed bottom-0 left-0 right-0 border-t border-[#cfd4dd] bg-white py-3 sm:py-4 px-4 sm:px-6">
        <div className="mx-auto flex max-w-[55rem] w-full items-center justify-between gap-2">
          <div className={`h-10 w-24 ${pulse}`} />
          <div className="flex gap-2">
            <div className={`h-10 w-24 ${pulse}`} />
            <div className={`h-10 w-28 ${pulse}`} />
          </div>
        </div>
      </div>
    </div>
  );
}
